import { connect } from 'dva';
import PropTypes from 'prop-types';
import React from 'react';
import { NOTEABLE_TYPES } from '../../../../lib/constants';
import SharePanel from '../../SharePanel';
import styles from './CollectionDetailSharing.module.scss';

export const CollectionDetailSharing = (props) => {
  return (
    <div className={styles.shareContainer}>
      <SharePanel
        grantableId={props.selectedCollection.uuid}
        grantableType={NOTEABLE_TYPES.Collection}
        isOwner={props.selectedCollection.isOwner}
      />
    </div>
  );
};

CollectionDetailSharing.propTypes = {
  selectedCollection: PropTypes.object
};

export default connect(model => ({
  selectedCollection: model.collections.selectedCollection
}))(CollectionDetailSharing);
